<template>
  <section class="py-0" style="scroll-snap-type: y mandatory;">
    <section id="mission" class="neo-inverse h-screen flex items-center relative" style="scroll-snap-align: start;">
      <div class="division px-4">
        <h1 class="fluid font-semibold mb-4">Mission</h1>
        <h2>To create amazing products that have significant therapeutic advantages and offer benefits that contribute
          to substantial improvement in consumers’ lives for circumstances in which previously available solutions were
          unsatisfactory.</h2>
      </div>
    </section>
    <section id="purpose" class="neo h-screen flex items-center relative" style="scroll-snap-align: start;">
      <div class="division px-4">
        <h1 class="fluid font-semibold mb-4">Purpose</h1>
        <h2>Bring comfort and confidence to patients in times of need.</h2>
        <p class="text-base">Bring comfort <strong>(pain)</strong> and confidence <strong>(fear)</strong> to patients in times of need.</p>
      </div>
    </section>
    <section id="values" class="neo-inverse h-screen flex items-center relative" style="scroll-snap-align: start;">
      <div class="division px-4">
        <h1 class="fluid font-semibold mb-4">Values</h1>
        <h2>Excellence, Ownership, Teamwork.</h2>
      </div>
    </section>
    <section id="tagline" class="neo h-screen flex items-center relative" style="scroll-snap-align: start;">
      <div class="division px-4">
        <h1 class="fluid font-semibold mb-4">Tagline</h1>
        <h2>Driven by science focused on health</h2>
        <p class="text-base">Driven by science focused on <strong>efficient</strong> health solutions.</p>
      </div>
    </section>
    <section id="statement" class="neo-inverse h-screen flex items-center relative" style="scroll-snap-align: start;">
      <div class="division px-4">
        <h1 class="fluid font-semibold mb-4">Positioning Statement</h1>
        <p><strong>For people who want</strong> to get well and stay well faster using natural means and improve their lives through
          targeted, optimized good health,</p>
        <p><strong>Elements is the brand that</strong> produces the most sophisticated, efficient, and trusted solution</p>
        <p><strong>because</strong> their natural nutritional supplements are designed to address specific health conditions, developed
          based on latest scientific achievements by highly qualified doctors, scientists and professors, with premium
          ingredients and practices that meet and the highest industry standards, and efficacy proven in clinical
          trials. </p>
      </div>
    </section>
    <section id="identifiers" class="neo h-screen flex items-center relative" style="scroll-snap-align: start;">
      <div class="division px-4">
        <h1 class="fluid font-semibold mb-4">Brand Voice</h1>
        <h2><strong>Key identifiers:</strong> Highest quality, excellence, efficacy, intelligent, cutting-edge, uncompromising attention to research &
          testing</h2>
      </div>
    </section>
    <section id="personification" class="inverse h-screen flex items-center bg-no-repeat bg-center bg-contain relative"
             style="scroll-snap-align: start; background-image:url('img/JamesBond.jpg')"
    >
      <div class="division px-4">
        <p>Personification:</p>
        <h1 class="fluid font-semibold mb-4">James Bond</h1>
        <h2>What this personality represents is: smart, sophisticated, expertise; meticulous, consistent problem-solver;
          confident and prepared — a “good guy” who’s always ahead of the game</h2>
      </div>
    </section>
    <section id="conclusion" class="neo h-screen flex items-center relative" style="scroll-snap-align: start;">
      <div class="division px-4">
        <h1 class="fluid font-semibold mb-4">Conclusion</h1>
        <h2>The Elements brand is sophisticated, expert, and trustworthy.</h2>
        <p>To best reflect this, the Brand Voice should be: Confident, contemporary, and smart. There should be a
          simplicity of ease, but also enthusiasm for detail, and a hint of elegant humor — an accessible, calm
          expertise.
        </p>
      </div>
    </section>
    <div class="division mt-20" style="padding-bottom: 25vh">
      <prev-next/>
    </div>
  </section>
</template>
<script>
export default {
  name: "Brand",
  computed:{}
}
</script>

<style scoped>

</style>